// extracted by mini-css-extract-plugin
module.exports = {"root":"m-parent__3uRg9Bsq"};